import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'shared';
import { UserGroupRoleDto } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { AgGridUserGroupRoleSettings } from './AgGridUserGroupRoleSettings';

@Component({
    selector: 'group-roles-dialog',
    templateUrl: './group-roles-dialog.component.html',
    styleUrls: ['./group-roles-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GroupRolesDialogComponent implements OnInit {  

  rowData: UserGroupRoleDto[] = [];

  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  components: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridUserGroupRoleSettings

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  _db!:string;
  _tenantName!:string;
  _user!:string;

  constructor(public _dialogRef: MatDialogRef<GroupRolesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectService,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,    
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this._tenantName = this.tenantService.currentTenantName;

    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridUserGroupRoleSettings(this.translate);
    this.components = {};
    this.gridOptions = this.aggridSettings.agGridProjectUserGroupRolesSettings;

    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = (data as any).role as Array<string>;
    //       userRoles.forEach((dbrole: string) => {
    //         if (dbrole === 'admin') {
    //          this._db = dbrole;
    //         }
    //       });
    //     }
    //   }
    // });

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'Role';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if(this._db) {
             this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERGROUPROLESERROR"]}`)

//           let db:string = this.tenantService.currentTenantName;
//           this.tenantService.loadUserGroupRoles(db, this.data.id, this.data.projectId, this.filter).subscribe({
// //            this.projectService.loadUserGroupRoles(this.data.id, this.data.projectId, this.filter).subscribe({
//               next:(userGroupRoleDtos : UserGroupRoleDto[]) => {
//               this.rowData = userGroupRoleDtos.slice(this.filter.startRow, this.filter.endRow);
//               let lastRow = -1;
  
//               if (this.rowData.length <= this.filter.endRow) {
//                 lastRow = this.rowData.length;
//               }
//               params.successCallback(this.rowData, lastRow);
//                this.isLoadingResults = false;
//                this.isRateLimitReached = false;
//                this.resultsLength = this.rowData.length;
   
//                this.gridApi.hideOverlay();
  
//               //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERGROUPROLES"]} `);
//             },
//             error: (error: any) => {
//               this.isLoadingResults = false;
//               this.isRateLimitReached = true;
//               this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERGROUPROLESERROR"]}`)
//             }
//           });
        }
        else {
          //let db:string = this.tenantService.currentTenantName;
          this.tenantService.loadUserGroupRoles(this._tenantName, this.data.id, this.data.projectId, this.filter).subscribe({
            next:(userGroupRoleDtos : UserGroupRoleDto[]) => {
              this.rowData = userGroupRoleDtos.slice(this.filter.startRow, this.filter.endRow);
              this._user = this.rowData[0].name;
              let lastRow = -1;
  
              if (this.rowData.length <= this.filter.endRow) {
                lastRow = this.rowData.length;
              }
              params.successCallback(this.rowData, lastRow);
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.resultsLength = this.rowData.length;
   
               this.gridApi.hideOverlay();
  
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERGROUPROLES"]} `);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERGROUPROLESERROR"]}`)
            }
          });
        }
      }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.updateGridOptions({datasource: this.ds})
  } 

  cancel(){
    this._dialogRef.close();
  }
}
